import React from 'react';
import axios, { CancelTokenSource } from 'axios';
import { connect } from 'react-redux';

import ConfirmationModal from '../../shared/modal/ConfirmationModal';
import Icon from '../icon/Icon';

import { IApplicationState } from '../../../store/applicationState';
import { addFavoriteDocument, removeFavoriteDocument } from '../../../store/group/groupActions';

interface IStateProps {
    viewerIsDi: boolean;
}

interface IOwnProps {
    id: string;
    groupId: string;
    meetingId: string
    isFavorite: boolean;
}

interface IDispatchProps {
    addFavoriteDocument: typeof addFavoriteDocument;
    removeFavoriteDocument: typeof removeFavoriteDocument;
}

type Props = IStateProps & IOwnProps & IDispatchProps;

interface IOwnState {
    isFavorite: boolean;
    isRemoving: boolean;
    isSpinning: boolean;
}

class DocumentFavorite extends React.Component<Props, IOwnState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isFavorite: this.props.isFavorite,
            isRemoving: false,
            isSpinning: false
        };
    }

    public render() {
        return this.props.viewerIsDi &&
            <React.Fragment>
                {this.props.isFavorite ?
                    <span id="removefavorite" key="removefavorite" onClick={this.toggleRemovingFavoriteDocument} onMouseUp={this.stopTrackDownloadPropagation}><Icon key="removefavoriteicon" name="star-filled" /></span>
                    :
                    <span id="addfavorite" key="addfavorite" onClick={this.addFavoriteDocument(this.props.id)} onMouseUp={this.stopTrackDownloadPropagation}><Icon key="addfavoriteicon" name="star" /></span>
                }
                <ConfirmationModal show={this.state.isRemoving} onAccept={this.removeFavoriteDocument(this.props.id)} buttonsClickable={!this.state.isSpinning} onReject={this.toggleRemovingFavoriteDocument} acceptText="Fjern">
                    <h3>Fjern fremhævet dokument</h3>
                    <p>Ønsker du at stoppe med at fremhæve dette dokument?</p>
                </ConfirmationModal>
            </React.Fragment>
    }

    private addFavoriteDocument = (id: string) => (e: React.MouseEvent<HTMLSpanElement>) => {
        e.preventDefault();

        this.props.addFavoriteDocument(this.props.groupId, this.props.meetingId, id)
    }

    private toggleRemovingFavoriteDocument = (e: React.FormEvent<HTMLElement> | React.MouseEvent<HTMLElement> | KeyboardEvent) => {
        e.preventDefault();

        this.setState(prevState => ({
            isRemoving: !prevState.isRemoving
        }));
    }

    private removeFavoriteDocument = (id: string) => () => {
        this.setState({
            isSpinning: true
        });

        this.props.removeFavoriteDocument(this.props.groupId, this.props.meetingId, id)

        this.setState({
            isRemoving: false,
            isSpinning: false
        });
    }

    private stopTrackDownloadPropagation = (e: React.MouseEvent<HTMLSpanElement>) => {
        e.preventDefault();
        e.stopPropagation();
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => ({
    viewerIsDi: state.oidc.user && state.oidc.user.profile && state.oidc.user.profile.role === 'DI'
});

const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
    addFavoriteDocument: (groupId: string, meetingId: string, documentId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(addFavoriteDocument(groupId, meetingId, documentId, cancelToken)),
    removeFavoriteDocument: (groupId: string, meetingId: string, documentId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(removeFavoriteDocument(groupId, meetingId, documentId, cancelToken))
});

const container = connect(mapStateToProps, mapDispatchToProps)(DocumentFavorite);

export default container;